"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IDPSEditorIntegrationFeature = IDPSEditorIntegrationFeature;
const practice_idps_web_1 = require("@branch-ts/practice-idps-web");
async function IDPSEditorIntegrationFeature(config) {
    await (0, practice_idps_web_1.FatPuriIntegration)().setup();
    // Match Era's FatIDPS wiring: do not install FatCasIntegration's legacy
    // @idps creation shortcut. IDPS links and exchange-block runes stay enabled.
    (0, practice_idps_web_1.FatRegisterExchangeBlockRunes)({}).setup({
        editorKind: config.editorKind,
    });
}
